import { compose, withProps } from 'coact/recompose'

import { connect } from 'react-redux'

// const R = require('ramda')

// const actions = require('../actions.js')

const schema = {
  type: 'Object',
  contents: {
    product: {
      type: 'ObjectId',
      reference: 'products',
      label: '商品型號',
      refKeys: ['key'],
      watcher: { name: 'queryReferenceData' },
    },
  },
}

const container = compose(
  connect(),

  withProps({ schema }),
)

export default container
